import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Input, Output, inject, type OnDestroy } from '@angular/core';
import { PorscheDesignSystemModule, ToastManager } from '@porsche-design-system/components-angular';
import { BehaviorSubject, distinctUntilChanged, tap } from 'rxjs';
import { SubSink } from 'subsink';
import type { EduExpensePurpose } from '../../../shared/models/api/edu-expense-purpose.model';
import { EduExpensePurposeService } from '../../../shared/services/api/edu-expense-purpose.service';

@Component({
  selector: 'opa-edu-expense-purpose-delete',
  imports: [CommonModule, PorscheDesignSystemModule],
  templateUrl: './edu-expense-purpose-delete.component.html',
  styleUrl: './edu-expense-purpose-delete.component.scss',
})
export class EduExpensePurposeDeleteComponent implements OnDestroy {
  private readonly eduExpensePurposeService = inject(EduExpensePurposeService);
  private readonly toastManager = inject(ToastManager);

  @Input({ required: true }) open = false;
  @Input({ required: true }) eduExpensePurpose: EduExpensePurpose | undefined = undefined;
  @Output() dismiss = new EventEmitter<EduExpensePurpose | undefined>();

  private readonly subSink = new SubSink();
  private readonly submitting = new BehaviorSubject(false);
  readonly submitting$ = this.submitting.pipe(distinctUntilChanged());

  ngOnDestroy(): void {
    this.subSink.unsubscribe();
  }

  close(eduExpensePurpose?: EduExpensePurpose): void {
    this.dismiss.emit(eduExpensePurpose);
  }

  submit(): void {
    const eduExpensePurpose = this.eduExpensePurpose;
    if (!eduExpensePurpose) return;

    this.submitting.next(true);
    this.subSink.sink = this.eduExpensePurposeService
      .deleteEduExpensePurpose(eduExpensePurpose.id)
      .pipe(
        tap({
          next: () => {
            this.toastManager.addMessage({
              text: `Purpose ${eduExpensePurpose.name} deleted`,
              state: 'success',
            });
            this.submitting.next(false);
            this.dismiss.emit(eduExpensePurpose);
          },
          error: () => this.submitting.next(false),
        }),
      )
      .subscribe();
  }
}
